import { SubstitutionReportType } from '@bp/planung-graphql-types';
import { apiHelper } from './apiHelper';
import { showSuccessCreateToast, showSuccessDeleteToast, showUserDbErrorToast } from './toast';

export const downloadSubstitutionReport = async (schoolYearUuid: string, day: string) => {
  await apiHelper<void>({
    method: 'GET',
    path: `/substitution-plan/${schoolYearUuid}/${day}`,
    type: 'download',
  });
};

export const downloadSubstitutionStudentReport = async (schoolYearUuid: string, day: string) => {
  await apiHelper<void>({
    method: 'GET',
    path: `/substitution-plan-student/${schoolYearUuid}/${day}`,
    type: 'download',
  });
};

export const createSubstitutionStatsTotal = async (schoolYearUuid: string) => {
  const response = await apiHelper<{ uuid: string }>({
    method: 'POST',
    path: `/substitution-stats/${schoolYearUuid}`,
  });

  if (response) {
    showSuccessCreateToast();
  } else {
    showUserDbErrorToast();
  }
};

export const createSubstitutionStatsMonthly = async (schoolYearUuid: string) => {
  const response = await apiHelper<{ uuid: string }>({
    method: 'POST',
    path: `/substitution-stats-monthly/${schoolYearUuid}`,
  });

  if (response) {
    showSuccessCreateToast();
  } else {
    showUserDbErrorToast();
  }
};

export const createSubstitutionStatsExcel = async (schoolYearUuid: string) => {
  const response = await apiHelper<{ uuid: string }>({
    method: 'POST',
    path: `/substitution-stats-excel-monthly/${schoolYearUuid}`,
  });

  if (response) {
    showSuccessCreateToast();
  } else {
    showUserDbErrorToast();
  }
};

export const downloadSubstitutionStats = async (uuid: string, type: SubstitutionReportType) => {
  await apiHelper<void>({
    method: 'GET',
    path: `/substitution/${type}/${uuid}`,
    type: 'download',
  });
};

export const deleteSubstitutionStats = async (uuid: string, type: SubstitutionReportType) => {
  const response = await apiHelper<{ message: string }>({
    method: 'DELETE',
    path: `/substitution/${type}/${uuid}`,
  });

  if (response) {
    showSuccessDeleteToast();
  } else {
    showUserDbErrorToast();
  }

  return response;
};
